import { Search, Share2 } from 'lucide-react';

const normalize = (channel: string) =>
  channel.toLowerCase().replace(/^paid\s+/, '');

export const ChannelIcon = ({ channel, className = 'w-3.5 h-3.5' }: { channel: string; className?: string }) => {
  const key = normalize(channel);
  if (key === 'search') return <Search className={className} />;
  if (key === 'social') return <Share2 className={className} />;
  return null;
};
